import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import ErrorPage from 'pages/Error/404';
import Desktop from 'pages/StudentViewAssignment/desktop';
import Mobile from 'pages/StudentViewAssignment/mobile';
import Tablet from 'pages/StudentViewAssignment/tablet';
import { useHistory, useParams } from 'react-router-dom';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { isLoading, assignments, currentAssignmentId, currentAssignment, batch, formative, studentSubmissions } =
        useApp();
    const history = useHistory();
    const params = useParams();
    const { device } = useViewport();

    const handleClickBack = () => {
        history.push('/assignments');
    };

    const handleClickProceed = () => {
        if (!formative) {
            history.push(`/assignments/${currentAssignmentId}/settings`);
        } else {
            history.push(`/assignments/${currentAssignmentId}/submissions`);
        }
    };

    const props = {
        assignment: currentAssignment,
        batch,
        formative,
        studentSubmissions,
        onClickBack: handleClickBack,
        onClickProceed: handleClickProceed,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    if (isLoading || currentAssignmentId !== params.id || !batch || typeof formative === 'undefined')
        return <Loading />;

    if (assignments && !currentAssignment) return <ErrorPage />;

    return <>{renderResponsiveLayout(device)}</>;
};

export default PageLayout;
